const GuideData = [
  {
    issueName: "Company Not Visible in Connector?",
    issueSolutions: [
      {
        issueSolutionTitle: "Incomplete Tally Software Initialization",
        issueSolutionDescription:
          "Make sure that the Tally software is properly initialized on the user's system. If it's not open, advise the user to launch Tally and ensure it's running smoothly before attempting to connect again. A properly initialized Tally software is crucial for successful integration with the connector.",
      },
      {
        issueSolutionTitle: "Incorrect Configuration Settings",
        issueSolutionDescription:
          "Ensure that the configuration settings within the connector match the Tally software settings accurately. Verify that the correct Tally version, company name, and other relevant details are entered correctly. Misconfigured settings can lead to connectivity issues and prevent the company from being visible in the connector.",
      },
      {
        issueSolutionTitle: "Network Connectivity Problems",
        issueSolutionDescription:
          "Check for any connectivity issues between the user's system and the Tally server. Verify that the network connection is stable and that the user has access to the Tally server. Troubleshoot any network-related issues or contact the IT department for further assistance if needed.",
      },
    ],
  },
  {
    issueName: "Incorrect Data Mapping?",
    issueSolutions: [
      {
        issueSolutionTitle: "Data Mapping Misalignment",
        issueSolutionDescription:
          "Verify that the data mapping within the connector accurately reflects the structure and format of the data in Tally. Any misalignment in data mapping can lead to discrepancies in data synchronization and result in incorrect data representation.",
      },
      {
        issueSolutionTitle: "Mapping Parameter Mismatch",
        issueSolutionDescription:
          "Check for any discrepancies in the mapping parameters set up within the connector. Ensure that the mapping parameters match the data fields in Tally precisely to prevent any data mapping errors.",
      },
    ],
  },
  {
    issueName: "Data Sync Error?",
    issueSolutions: [
      {
        issueSolutionTitle: "Sync Process Interruption",
        issueSolutionDescription:
          "Investigate any interruptions or errors that occurred during the data synchronization process. Address any underlying issues promptly to ensure a smooth and error-free data synchronization process in the future.",
      },
    ],
  },
  {
    issueName: "Incorrect Data Calculation?",
    issueSolutions: [
      {
        issueSolutionTitle: "Calculation Logic Error",
        issueSolutionDescription:
          "Review the calculation logic implemented within the connector to identify any errors or discrepancies. Ensure that the calculation algorithms accurately reflect the intended calculations to prevent incorrect data calculations.",
      },
      {
        issueSolutionTitle: "Data Input Inconsistency",
        issueSolutionDescription:
          "Check for any inconsistencies in the data inputted into the connector. Ensure that the data entered adheres to the specified format and standards to avoid discrepancies in data calculations.",
      },
      {
        issueSolutionTitle: "Formula Parsing Issue",
        issueSolutionDescription:
          "Investigate any issues related to the parsing of formulas within the connector. Ensure that the formulas are parsed correctly and that there are no syntax errors affecting the accuracy of data calculations.",
      },
    ],
  },
  {
    issueName: "Missing Data in Reports?",
    issueSolutions: [
      {
        issueSolutionTitle: "Data Filtering Error",
        issueSolutionDescription:
          "Check for any errors in the data filtering process within the connector. Ensure that the filtering criteria are accurately defined to include all relevant data in the reports and prevent any data from being omitted.",
      },
    ],
  },
  {
    issueName: "Slow Performance?",
    issueSolutions: [
      {
        issueSolutionTitle: "Performance Optimization",
        issueSolutionDescription:
          "Optimize the performance of the connector by implementing efficient algorithms and optimizing resource utilization. Identify and address any bottlenecks or inefficiencies in the system to improve overall performance.",
      },
      {
        issueSolutionTitle: "Resource Overload",
        issueSolutionDescription:
          "Investigate any instances of resource overload or excessive resource consumption within the connector. Allocate resources appropriately and implement measures to prevent resource exhaustion, which can lead to slow performance.",
      },
    ],
  },
  {
    issueName: "Authentication Failure?",
    issueSolutions: [
      {
        issueSolutionTitle: "Authentication Credentials Verification",
        issueSolutionDescription:
          "Verify the authentication credentials provided by the user to ensure their accuracy. Double-check the username, password, and any other authentication details to prevent authentication failures during the connection process.",
      },
      {
        issueSolutionTitle: "Token Expiration",
        issueSolutionDescription:
          "Check for any issues related to token expiration or invalidation. Ensure that the authentication tokens used for accessing the connector services are up-to-date and have not expired to avoid authentication failures.",
      },
    ],
  },
  {
    issueName: "Data Import Error?",
    issueSolutions: [
      {
        issueSolutionTitle: "Data Format Compatibility",
        issueSolutionDescription:
          "Ensure that the data being imported into the connector is in a compatible format supported by the system. Verify that the data format matches the specifications required by the connector to prevent data import errors.",
      },
      {
        issueSolutionTitle: "Data Parsing Issues",
        issueSolutionDescription:
          "Investigate any issues related to data parsing during the import process. Ensure that the data is parsed correctly and that there are no formatting errors affecting the import process.",
      },
      {
        issueSolutionTitle: "Data Integrity Validation",
        issueSolutionDescription:
          "Perform data integrity validation checks to identify any inconsistencies or errors in the imported data. Implement measures to ensure the integrity and accuracy of the imported data to prevent data import errors.",
      },
      {
        issueSolutionTitle: "Import Data Verification",
        issueSolutionDescription:
          "Verify the imported data to ensure its accuracy and completeness. Double-check the imported data against the source to identify any discrepancies or missing information and take corrective actions as necessary.",
      },
      {
        issueSolutionTitle: "Data Import Mapping",
        issueSolutionDescription:
          "Review the data import mapping configurations to ensure that the data is mapped correctly to the destination fields. Verify that the mapping parameters are accurately defined to prevent any data import mapping errors.",
      },
    ],
  },
];

export default GuideData;
